import React from "react";
import Shadow from "../Shadow";
import RadioBox from "../forms/RadioBox";

// Затычка
export default props => {
    return <div className={"bl_4_grid_item"}>
        {props.shadow && <Shadow />}
        <div className="calc_title_box">
            <div className="calc_title">Толщина</div>
            <RadioBox name={"depth"} value={"4"} txt={"4мм"}/>
            <RadioBox name={"depth"} value={"5"} txt={"5мм"}/>
            <RadioBox name={"depth"} value={"6"} txt={"6мм"}/>
            <RadioBox name={"depth"} value={"8"} txt={"8мм"}/>
            <RadioBox name={"depth"} value={"10"} txt={"10мм"}/>
        </div>
    </div>
}
